module.exports = __webpack_public_path__ + "media/recipes/51-bdbfa85e.png";